"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _assert = _interopRequireDefault(require("assert"));

var _axios = _interopRequireDefault(require("axios"));

var _matchPath = require("./matchPath");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Client = /*#__PURE__*/function () {
  function Client(props) {
    _classCallCheck(this, Client);

    this.API_URI = props.API_URI;
    this.axios = props.axios || _axios.default;
    this.queryCache = {};
    this.objectCache = {};
  }

  _createClass(Client, [{
    key: "_checkCookie",
    value: function _checkCookie(res) {
      if (typeof window !== 'undefined') return;

      if (Array.isArray(res.headers['set-cookie'])) {
        this.setCookie = res.headers['set-cookie'][0];
      }
    }
  }, {
    key: "_findObjects",
    value: function _findObjects(inp) {
      var _this = this;

      var outp = [];

      if (Array.isArray(inp)) {
        inp.filter(function (key) {
          return _typeof(inp[key]) === 'object';
        }).forEach(function (obj) {
          return outp = outp.concat(_this._findObjects(obj));
        });
      } else if (_typeof(inp) === 'object' && inp !== null) {
        if (inp._type && inp._id) {
          outp.push(inp);
        }

        Object.keys(inp).filter(function (key) {
          return _typeof(inp[key]) === 'object';
        }).forEach(function (obj) {
          return outp = outp.concat(_this._findObjects(obj));
        });
      }

      return outp;
    }
  }, {
    key: "_invalidateInQueryCache",
    value: function _invalidateInQueryCache(cacheKeyExpr) {}
  }, {
    key: "_storeInCache",
    value: function _storeInCache(cacheKey, data) {
      var _this2 = this; // Store entity objects in objectCache


      if (cacheKey) {
        this.queryCache[cacheKey] = data;
      }

      this._findObjects(data).forEach(function (obj) {
        if (_this2.objectCache["".concat(obj._type, ".").concat(obj._id)]) {
          var cacheObj = _this2.objectCache["".concat(obj._type, ".").concat(obj._id)];

          Object.keys(obj).forEach(function (key) {
            return cacheObj[key] = obj[key];
          });
        } else {
          _this2.objectCache["".concat(obj._type, ".").concat(obj._id)] = obj;
        }
      });
    }
  }, {
    key: "_fetchFromCache",
    value: function _fetchFromCache(cacheKey) {
      // TODO: Fetch entity objects from objectCache
      // TODO: Should I use shared pointer to keep them
      // updated or should I create new objects and
      // make sure network calls are performed first?
      return this.queryCache[cacheKey];
    }
  }, {
    key: "_toCacheKey",
    value: function _toCacheKey(inp) {
      if (Array.isArray(inp)) {
        var tmp = [];

        for (var i = 0; i < inp.length; i++) {
          var val = this._toCacheKey(inp[i]);

          tmp.push(val);
        }

        return "[".concat(tmp.join(','), "]");
      } else if (_typeof(inp) === 'object') {
        var _tmp = [];
        var keys = Object.keys(inp).sort();

        for (var _i = 0; _i < keys.length; _i++) {
          var key = keys[_i];

          var _val = this._toCacheKey(inp[key]);

          _tmp.push("".concat(key, "=").concat(_val));
        }

        return _tmp.join('&');
      } else {
        return inp;
      }
    }
  }, {
    key: "hydrate",
    value: function hydrate() {
      return this.queryCache;
    }
  }, {
    key: "rehydrate",
    value: function rehydrate(state) {
      var _this3 = this;

      if (state) {
        Object.keys(state).forEach(function (key) {
          return _this3._storeInCache(key, state[key]);
        });
      }
    }
  }, {
    key: "invalidateCache",
    value: function invalidateCache(pathExp) {
      var _this4 = this;

      if (pathExp === '*') {
        // Clear all data (used for logins)
        this.queryCache = {};
        this.objectCache = {};
        return;
      }

      var cacheKeyExpr = Array.isArray(pathExp) ? pathExp : [pathExp];
      var tmpClearKeys = Object.keys(this.queryCache).filter(function (key) {
        // Loop through all invalidation expressions to see if we get a match
        return cacheKeyExpr.reduce(function (prev, curr) {
          return prev || (0, _matchPath.matchPath)(curr, {
            path: key,
            exact: true
          }, undefined);
        });
      });
      tmpClearKeys.forEach(function (key) {
        delete _this4.queryCache[key];
      });
    }
  }, {
    key: "query",
    value: function query(opts) {
      var _this5 = this;

      var inp, wasArray;

      if (Array.isArray(opts)) {
        inp = opts;
        wasArray = true;
      } else {
        inp = [opts];
      }

      var outp = inp.map(function (_ref) {
        var URI = _ref.URI,
            query = _ref.query,
            sortBy = _ref.sortBy,
            shape = _ref.shape,
            _ref$cache = _ref.cache,
            cache = _ref$cache === void 0 ? true : _ref$cache;
        var queryCacheKey;

        if (query) {
          (0, _assert.default)(_typeof(query) === 'object');
          queryCacheKey = _this5._toCacheKey({
            query: query,
            sortBy: sortBy,
            shape: shape
          });
        }

        var cacheKey = URI + (queryCacheKey ? "?".concat(queryCacheKey) : '');

        if (cache) {
          if (_this5.queryCache.hasOwnProperty(cacheKey)) {
            // console.log('From CACHE....')
            // Check that all objects still exist and return result as resolved promise
            var result = _this5._fetchFromCache(cacheKey);

            return {
              URI: URI,
              method: 'query',
              query: query,
              sortBy: sortBy,
              shape: shape,
              result: result
            };
          }
        }

        return {
          URI: URI,
          method: 'query',
          query: query,
          sortBy: sortBy,
          shape: shape,
          cacheKey: cacheKey
        };
      });
      var actions = outp.filter(function (item) {
        return item.cacheKey;
      }); // If everything is cached we can return it immediately

      if (actions.length === 0) {
        var result = outp.map(function (item) {
          return item.result;
        });
        return {
          result: wasArray ? result : result[0],
          data: wasArray ? result.map(function (item) {
            return item.body;
          }) : result[0].body // for compat

        };
      } // Otherwise, call backend and return results when
      // all the queries have been resolved


      return this.axios({
        method: 'post',
        withCredentials: true,
        url: this.API_URI,
        data: {
          actions: actions
        }
      }).then(function (res) {
        _this5._checkCookie(res); // console.log('Request....')


        outp.forEach(function (item) {
          if (item.cacheKey) {
            item.result = res.data[item.cacheKey];

            _this5._storeInCache(item.cacheKey, item.result);

            delete item.cacheKey;
          }
        });
        var result = outp.map(function (item) {
          return item.result;
        });
        return {
          result: wasArray ? result : result[0],
          data: wasArray ? result.map(function (item) {
            return item.body;
          }) : result[0].body // for compat

        }; // Note: I passed a status prop before but it was pretty useless som removed it
      });
    }
  }, {
    key: "_mutation",
    value: function _mutation(method, opts) {
      var _this6 = this;

      var inp, wasArray;

      if (Array.isArray(opts)) {
        inp = opts;
        wasArray = true;
      } else {
        inp = [opts];
      } // Update cached objects
      // How do we invalidate cached queries?
      // Call backend and return results when
      // all the queries have been resolved


      var actions = inp.map(function (_ref2, index) {
        var URI = _ref2.URI,
            shape = _ref2.shape,
            data = _ref2.data,
            invalidate = _ref2.invalidate;
        return {
          URI: URI,
          method: method,
          shape: shape,
          data: data,
          cacheKey: index,
          invalidate: invalidate
        };
      });
      return this.axios({
        method: 'post',
        withCredentials: true,
        url: this.API_URI,
        data: {
          actions: actions
        }
      }).then(function (res) {
        _this6._checkCookie(res);

        _this6._storeInCache(undefined, res.data);

        var result = actions.map(function (item) {
          // Invalidate cached queries if passed a pathExpr to
          // resolve which items should be invalidated
          if (item.invalidate) {
            _this6.invalidateCache(item.invalidate);
          }

          return res.data[item.cacheKey];
        });
        return {
          result: wasArray ? result : result[0],
          data: wasArray ? result.map(function (item) {
            return item.body;
          }) : result[0].body // for compat

        };
      });
    }
  }, {
    key: "create",
    value: function create(opts) {
      return this._mutation('create', opts);
    }
  }, {
    key: "update",
    value: function update(opts) {
      return this._mutation('update', opts);
    }
  }, {
    key: "delete",
    value: function _delete(opts) {
      return this._mutation('delete', opts);
    }
  }]);

  return Client;
}();

var _default = Client;
exports.default = _default;